/* eslint-disable react/jsx-max-depth */
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import queryString from 'querystring';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/elements/Button';
import Card from '../../components/elements/Card';
import Modal from '../../components/elements/Modal';
import { AppContext } from '../../contexts';
import { fetchTemplateHet, submitUploadUpdatePrice } from './actions';
import FormSettingHargaSekaligus from './FormSettingHargaSekaligus';
import styles from './styles.scoped.css';
import { useLocation } from 'react-router-dom';

export function SettingSekaligus(
  // {
  //   handleSubmit = () => { }
  // }
) {
  const dispatch = useDispatch();
  const location = useLocation();

  const { setBreadcrumbs } = useContext(AppContext);
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalMode, setModalMode] = useState('');

  const {
    region,
    provinceId = '',
    cityId = '',
  } = queryString.parse(location.search.replace('?', ''));

  useEffect(() => {
    setBreadcrumbs(['Atur HET LPG 3 Kg', 'Ubah Harga Dengan File']);
    dispatch(fetchTemplateHet(region === 'All' ? '' : region, provinceId, cityId));
  }, []);

  const {
    dataUploadUpdatePrice,
    messageUploadUpdatePrice,
    isLoadingUploadUpdatePrice
  } = useSelector((s) => s.prices);


  const handleDownloadDataFailRegist = () => {
    let a = document.createElement('a');
    a.href = messageUploadUpdatePrice?.link;
    a.click();
    setOpenModal(false);
  };

  const onBack = () => {
    let a = document.createElement('a');
    a.href = '/dc/price';
    a.click();
    setOpenModal(false);
  };

  useEffect(() => {
    if (afterSubmit && messageUploadUpdatePrice !== '' && messageUploadUpdatePrice !== undefined) {
      if (messageUploadUpdatePrice === 'Template Update Harga Tidak Sesuai') {
        setOpenModal(true);
        setModalMode('somethingWrong');
      } else {
        setOpenModal(true);
        setModalMode('fail');
      }
    } else if (afterSubmit && messageUploadUpdatePrice === '' && !isLoadingUploadUpdatePrice) {
      setOpenModal(true);
      setModalMode('success');
    }
  }, [dataUploadUpdatePrice, messageUploadUpdatePrice]);

  return (
    <div className={styles.form}>
      <Card className={styles.card}>
        <FormSettingHargaSekaligus
          _handleBack={onBack}
          _handleDownload={handleDownloadDataFailRegist}
          onSubmit={(values) => dispatch(submitUploadUpdatePrice(values, setAfterSubmit(true)))}
        />
      </Card>
      <Modal className={styles['modal-reg-success']} open={openModal}>
        <span onClick={() => setOpenModal(false)}>
          <img className={styles['close-icon-modal']} src="assets/ic-close.svg" />
        </span>
        <br />
        {modalMode === 'successWithFail' ? <h5>Sebagian data berhasil diunggah</h5> :
          <h5>Unggah file {modalMode === 'success' ? 'berhasil' : 'gagal'}</h5>
        }
        <hr className={styles.separatirModal} />
        <br />
        {modalMode === 'fail' && <p>
          Data gagal diupload. Segera perbaiki data yang gagal dan unggah kembali.</p>}
        {modalMode === 'somethingWrong' && <p>File yang diunggah tidak sesuai format, segera periksa data dan unggah kembali</p>}
        <br />
        <br />
        {modalMode === 'success' && <Button
          className={styles['action-btn-modal']}
          onClick={onBack}
        >
          Ok
        </Button>}
        {modalMode === 'fail' && <Button
          className={styles['action-btn-modal']}
          onClick={() => handleDownloadDataFailRegist()}
        >
          Tutup dan Unduh Data Gagal
        </Button>}
        {modalMode === 'somethingWrong' && <Button
          className={styles['action-btn-modal']}
          onClick={() => {
            setOpenModal(false),
            setAfterSubmit(false);
          }}
        >
          Ok
        </Button>
        }
      </Modal>
    </div>
  );
}

SettingSekaligus.propTypes = {
  handleSubmit: PropTypes.func
};
export default SettingSekaligus;
